var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccesibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    y: 0.620117,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E3F0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7809 26.053C20.9003 26.053 21.0197 26.0231 21.1391 25.9634C21.5869 25.7545 21.766 25.247 21.557 24.7992C21.557 24.7992 19.9152 21.038 19.6167 19.6649C19.4973 19.1873 19.4376 17.9037 19.4078 17.3067C19.4078 17.0977 19.5272 16.9186 19.7063 16.8589L23.3779 15.7545C23.8257 15.6351 24.0943 15.1276 23.9749 14.6798C23.8555 14.2321 23.3481 13.9634 22.9003 14.0828C22.9003 14.0828 19.4973 15.1873 18.2734 15.1873C17.0794 15.1873 13.7063 14.1127 13.7063 14.1127C13.2585 13.9933 12.7511 14.2022 12.6018 14.65C12.4525 15.1276 12.7212 15.6351 13.1988 15.7545L16.8705 16.8589C17.0496 16.9186 17.1988 17.0977 17.169 17.3067C17.1391 17.9037 17.0794 19.1873 16.96 19.6649C16.6615 21.038 15.0197 24.7992 15.0197 24.7992C14.8108 25.247 15.0197 25.7545 15.4376 25.9634C15.557 26.0231 15.6764 26.053 15.7958 26.053C16.1242 26.053 16.4525 25.8739 16.572 25.5455L18.3331 21.9634L20.0048 25.5753C20.154 25.8739 20.4526 26.053 20.7809 26.053Z",
    fill: "#378ED1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.3216C19.2565 14.3216 20.0049 13.5731 20.0049 12.6499C20.0049 11.7267 19.2565 10.9783 18.3333 10.9783C17.41 10.9783 16.6616 11.7267 16.6616 12.6499C16.6616 13.5731 17.41 14.3216 18.3333 14.3216Z",
    fill: "#378ED1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.37012C25.0982 6.37012 30.5833 11.8552 30.5833 18.6201C30.5833 25.3851 25.0982 30.8701 18.3333 30.8701C11.5683 30.8701 6.08325 25.3851 6.08325 18.6201C6.08325 11.8552 11.5683 6.37012 18.3333 6.37012ZM18.3333 7.85547C12.3822 7.85547 7.5686 12.698 7.5686 18.6201C7.5686 24.5417 12.4116 29.3848 18.3333 29.3848C24.2549 29.3848 29.0979 24.5417 29.0979 18.6201C29.0979 12.698 24.2843 7.85547 18.3333 7.85547Z",
    fill: "#378ED1",
    stroke: "#378ED1",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesibility);
export default __webpack_public_path__ + "static/media/accesibility.a9e3698f25514f811bf37f37237f5c2c.svg";
export { ForwardRef as ReactComponent };